import ReactDOMServer from "react-dom/server";
import Item from "./components/Item";
import { updateListToolsAPI } from "../../../../apis/ToolAPI";

// TODO(#27 followup): audit gridstack v12 runtime behavior. Compared to v4 the
// following init opts changed surface: `dragOut`, `dragIn`, `disableResize`,
// `disableOneColumnMode` are no longer top-level GridStackOptions fields (v5+
// dropped jquery-ui; native DD is built-in). Unknown options are ignored at
// runtime but drag-in/drag-out between grids may need `GridStack.setupDragIn()`
// and per-grid `acceptWidgets` revisit. See the homepage SorintTools grid.

export function insertItemsTools(itemsTools, grid) {

  itemsTools.forEach((item) => {
    const rawHtml = ReactDOMServer.renderToString(
      <a className="tag-a-tool" href={item.url} target="_blank" rel="noreferrer" id={item.toolName}>
        <Item {...item} key={item.id} grid={grid} />
      </a>
    );
    // React 19 injects <link rel="preload"> for every <img>. Strip them
    // because this HTML is meant for gridstack widgets, not SSR hydration.
    const elem = rawHtml.replace(/<link[^>]*rel="preload"[^>]*\/?>/gi, "");
    grid.addWidget({ content: elem, autoPosition: true, id: item.id });
  });
}

export const MAX_NUM_ITEMS_IN_ROW = Math.round(document.body.clientWidth / 170) > 12 ? 12 : Math.round(document.body.clientWidth / 170);

export function setGridOptions(numFavorite) {
  const widthDevice = document.body.clientWidth;
  const halfHeightGrid1 = widthDevice > 760 ? 180 : 150;

  const optsGeneral = {
    dragOut: true,
    float: false,
    dragIn: true,
    cellHeightUnit: "px",
    acceptWidgets: true,
    disableResize: true,
    disableOneColumnMode: "grid-stack-one-column-mode",
    handle: ".grid-stack-item-content",
  };

  const opts_empty = {
    ...optsGeneral,
    staticGrid: true,
    cellHeight: halfHeightGrid1,
    row: widthDevice < 1030 ? 2 : 1,
    column: widthDevice < 1030 ? numFavorite / 2 : numFavorite,
  };

  const opts1 = {
    ...optsGeneral,
    cellHeight: halfHeightGrid1,
    row: widthDevice < 1030 ? 2 : 1,
    column: widthDevice < 1030 ? numFavorite / 2 : numFavorite,
  };

  const opts2 = {
    ...optsGeneral,
    cellHeight: 100,
    column: MAX_NUM_ITEMS_IN_ROW,
  };

  return { optsGeneral, opts_empty, opts1, opts2 };
}

export function resizeGrid(grid_empty, grid1, grid2) {
  const layout = "moveScale";
  const maxNumItemsInRow = Math.round(document.body.clientWidth / 170) > 12 ? 12 : Math.round(document.body.clientWidth / 170);
  const widthDeviceResize = document.body.clientWidth;
  grid_empty.column(widthDeviceResize < 1030 ? 3 : 6, layout);
  grid1.column(widthDeviceResize < 1030 ? 3 : 6, layout);
  grid2.column(maxNumItemsInRow, layout);
  grid_empty.compact();
  grid1.compact();
  grid2.compact();
}

export function saveUserListTools(grid1, grid2) {
  try {
    const updateList = async (data) => {
      try {
        await updateListToolsAPI(data)
      } catch {
        console.error("Error updating tools list");
      }
    };
    const serializedData1 = [];
    const serializedData2 = [];
    grid1.save().forEach((element) => serializedData1.push(element.id));
    grid2.save().forEach((element) => serializedData2.push(element.id));
    for (let i = serializedData1.length; i < 6; i++) {serializedData1.push("");}
    const updateToolsList = [...serializedData1, ...serializedData2].toString();
    updateList(updateToolsList);
  } catch {
    console.error("Error saving tools layout");
  }
}
